// extracted by mini-css-extract-plugin
export default {"typeaheadResult":"TypeaheadOption__typeaheadResult___VOl5v"};